import { Button, Stack } from '@mui/material';
import { ToolbarActionItem } from '@oh-vcp/components-common';
import { ActionItemParams } from '@oh-vcp/components-ui/src/types/ActionItemParams';
import React, { FC } from 'react';
import ApplyForProgEconPermissionAction from '../actions/ApplyForProgEconPermissionAction';
import EconsultAction from '../actions/EconsultAction';
import EditAction from '../actions/EditAction';
import PrintAction from '../actions/PrintAction';
import ProfileActionMenu from '../profileActionMenu/ProfileActionMenu';

export interface CustomButton {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
}

interface ProfileActionToolbarProps {
  toolbarActionItems: ToolbarActionItem[];
  params: ActionItemParams;
  numItemsToPin: number;
  customButtons?: CustomButton[];
}

const CustomToolbarButton: FC<CustomButton> = ({
  label,
  icon,
  onClick,
  disabled = false,
  color = 'primary'
}) => (
  <Button variant="contained" startIcon={icon} onClick={onClick} disabled={disabled} color={color}>
    {label}
  </Button>
);

const ProfileActionToolbar: FC<ProfileActionToolbarProps> = ({
  toolbarActionItems,
  params,
  numItemsToPin,
  customButtons = []
}) => {
  const pinnedItems = toolbarActionItems.slice(0, numItemsToPin);
  const unpinnedItems = toolbarActionItems.slice(numItemsToPin);

  return (
    <Stack direction="row" sx={{ columnGap: 2 }}>
      {customButtons.map((btn, index) => (
        <CustomToolbarButton key={index} {...btn} />
      ))}
      {
        // check if there are any unpinned items before rendering the ActionButton ellipsis
        (unpinnedItems.length && (
          <ProfileActionMenu params={params} toolbarActionItems={unpinnedItems} menuType="action" />
        )) ||
          null
      }
      {pinnedItems.map((actionItem) => {
        const { translationKey, name } = actionItem;
        switch (name) {
          case 'print':
            return <PrintAction translationKey={translationKey} actionType="toolbar" />;
          case 'econsult':
            return (
              <EconsultAction
                params={params}
                translationKey={translationKey}
                actionType="toolbar"
              />
            );
          case 'econsultApplyForPermission':
            return (
              <ApplyForProgEconPermissionAction
                programId={params.programId || ''}
                translationKey={translationKey}
                actionType="toolbar"
                programName={params.programName || ''}
              />
            );
          case 'edit':
            return (
              <EditAction params={params} translationKey={translationKey} actionType="toolbar" />
            );
          default:
            return null;
        }
      })}
    </Stack>
  );
};

export default ProfileActionToolbar;
